var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/organizationmanager/models/organizationbase',["require", "exports", "common/viewmodelbase", "common/constants"], function (require, exports, common, constants) {
    "use strict";
    var OrganizationBase = (function (_super) {
        __extends(OrganizationBase, _super);
        function OrganizationBase() {
            _super.call(this);
            this.name = "";
            this.typ = "";
            this.organizationTypes = new Array();
            this.title = $.t("app:modules.organizationmanager.headline_titleOrganizationManager", { ifMissing: "Organisationsverwaltung" });
            ko.track(this, ['name', 'typ', 'organizationTypes']);
        }
        OrganizationBase.prototype.onActivated = function (context) {
            if (this.organizationTypes.length == 0) {
                this.setOrganizationsTypes();
            }
        };
        OrganizationBase.prototype.setOrganizationsTypes = function () {
            var all = $.t("app:modules.common.constant_all", { ifMissing: "Alle" });
            this.organizationTypes.push({ organizationType: "Alle", displayName: all });
            var organizationType = constants.OrganizationTypes.Stb;
            var displayName = constants.OrganizationTypes.getDisplayNameForGivenOrganizationType(organizationType);
            this.organizationTypes.push({ organizationType: organizationType, displayName: displayName });
            organizationType = constants.OrganizationTypes.Client;
            displayName = constants.OrganizationTypes.getDisplayNameForGivenOrganizationType(organizationType);
            this.organizationTypes.push({ organizationType: organizationType, displayName: displayName });
        };
        return OrganizationBase;
    }(common.ListViewModelBase));
    exports.OrganizationBase = OrganizationBase;
});

